// src/components/forms/TextArea.tsx
import { forwardRef } from "react";

interface Props {
  label?: string;
  value: string;
  name: string;
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  placeholder?: string;
  rows?: number;
  className?: string;
  textareaClassName?: string; // Allowed style override for snapping to toolbars
}

export const TextArea = forwardRef<HTMLTextAreaElement, Props>(({ 
  label, 
  value, 
  name,
  onChange, 
  placeholder, 
  rows = 4, 
  className,
  textareaClassName
}, ref) => {
  return (
    <div className={`flex flex-col gap-1.5 ${className}`}>
      {/* Vibrant Indigo Label */}
      {label && (
        <label className="text-sm font-bold uppercase text-zinc-400 dark:text-indigo-200 ml-1">
          {label}
        </label>
      )}
      
      {/* 
        CRUCIAL FIX: Changed "group relative" to a grid layout. 
        This forces the background glow to dynamically stretch out perfectly 
        at the exact same rate the user drags and resizes the textarea element.
      */}
      <div className="group relative grid grid-cols-1 grid-rows-1">
        {/* Animated Gradient Background Glow */}
        <div className="absolute -inset-0.5 bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500 rounded-xl opacity-20 group-focus-within:opacity-100 transition duration-300 blur-[2px] pointer-events-none"></div>
        
        <textarea
          ref={ref} 
          rows={rows}
          value={value}
          name={name}
          placeholder={placeholder}
          onChange={onChange}
          className={`relative w-full bg-white dark:bg-zinc-900 px-4 py-3 
                     text-zinc-900 dark:text-zinc-100 
                     placeholder:text-zinc-400
                     border border-zinc-200 dark:border-zinc-700
                     focus:border-transparent focus:outline-none 
                     transition-all duration-200 
                     min-h-[150px] max-h-[800px] resize-y ${textareaClassName}`} 
        />
      </div>
    </div>
  );
});

TextArea.displayName = "TextArea";